var invoice4i = function(){
	var forms = new forms4i(),
	tooltips = new toolTips(),
	recaptchaSiteKey, recaptchaActionName,
	busyHTML = '<div id="invoiceLoading" class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
	verificationToken =  document.getElementById("mainContent").getElementsByTagName('input')[0].getAttribute("value"),
	authenticationLayer,
	accountingDeptPhone,
	officePhone, 
	emptyGuid = "00000000-0000-0000-0000-000000000000",
	init = function(){
		tooltips.init();
		accountingDeptPhone = document.getElementById("AccountingDeptPhone").value;
		officePhone = document.getElementById("OfficePhone").value;
		if (document.getElementsByClassName("recaptchaSiteKey")[0]) {
			recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value;
		}
		if (document.getElementsByClassName("recaptchaActionName")[0]) {
			recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value;
		}

		if(document.getElementById('btnSignIn')){
			document.getElementById('btnSignIn').addEventListener("click", function (e) {
				e.preventDefault();
				formEvents.ClearValidation(); //clears validation from pay as guest form
				if(document.getElementById("invoiceSignInForm").querySelector(".loginError")){ //remove error panel
					document.getElementById("invoiceSignInForm").querySelector(".loginError").classList.add("hide");
				}
				forms.formValidation(document.getElementById("invoiceSignInForm"), ajaxActions.SignIn, e);
			});
		}
		if (document.getElementById('PaymentMethod_CardNumber')) {
			document.getElementById('PaymentMethod_CardNumber').addEventListener('keyup', function () {
				forms.FadeCCImgs(document.getElementById('PaymentMethod_CardNumber'), document.getElementById('btnSubmitPymt'), null);
			});
		}
		if (document.getElementById('PaymentMethod_CardName')) {
			document.getElementById("PaymentMethod_CardName").addEventListener('blur', function(e) { e.target.value = forms.VerifyName(e.target.value); });
		}
		if(document.getElementById('btnPayInvoice')){
			document.getElementById('btnPayInvoice').addEventListener("click", function (e) {
				e.preventDefault();
				formEvents.ClearValidation(); //clears validation from sign in form
				forms.formValidation(document.getElementById("invoiceGuestForm"), formEvents.PayInvoice, e);	
			});
		}
		
		if(document.getElementById('btnSubmitPymt')){
			document.getElementById('btnSubmitPymt').addEventListener("click", function (e) {
				e.preventDefault();
				forms.UnmaskCCNumber(document.getElementById('PaymentMethod_CardNumber'));
				forms.formValidation(document.getElementById("paymentTotalForm"), formEvents.SubmitPayment, e);
				forms.MaskCCNumber(document.getElementById('ccMask'), document.getElementById('PaymentMethod_CardNumber'));
			});
			ccFormEvents();
			forms.MaskCCNumber(document.getElementById('ccMask'), document.getElementById('PaymentMethod_CardNumber'));
			forms.MaskCVVNumber(document.getElementById('cvvMask'), document.getElementById('PaymentMethod_CardCCV'));
		}
		if (document.getElementById("AuthenticationRequired") && document.getElementById("AuthenticationRequired").value == 'True') {
			const sessionId = document.getElementById('SessionID').value;
			const orderId = document.getElementById("SalesOrderGuid").value;
			const transactionId = document.getElementById("TransactionID").value;
			const merchantId = document.getElementById("MerchantID").value;
			if (typeof authenticationLayer4i !== 'undefined') {
				authenticationLayer4i.Init(orderId, 2, sessionId, transactionId, merchantId, formEvents.ShowAuthenticationError);
				authenticationLayer = authenticationLayer4i;
                	}
		}
	},
	ccFormEvents = function(){
		if(document.getElementById('PaymentMethod_CardNumber')){
			forms.MaskCCNumber(document.getElementById('ccMask'), document.getElementById('PaymentMethod_CardNumber'));
		}
		if (document.getElementById('PaymentMethod_CardName')) {
			document.getElementById("PaymentMethod_CardName").addEventListener('blur', function(e) { e.target.value = forms.VerifyName(e.target.value); });
		}
		var useAddressChks = [].slice.call(document.querySelectorAll(".useAddress"));
		var removeSelected = function(){
			for(var i = 0; i < useAddressChks.length; i++){
				useAddressChks[i].checked = false;
				useAddressChks[i].classList.remove("selectedAddress");
			}
		};
		useAddressChks.forEach(function(el, index, array){
			el.addEventListener('click', function (e) {
				e.preventDefault();
				removeSelected();
				el.classList.add("selectedAddress");
				el.parentNode.insertAdjacentHTML("beforeend", busyHTML);
				ajaxActions.BillingAddress(el);
			});
		});
	},

	formEvents = (function(){
		var showBusy = function(el){
			if (!document.getElementById("invoiceLoading")) {
				el.parentNode.insertAdjacentHTML("afterend", busyHTML);
			}
		}, 
		hideBusy = function(){
			if(document.getElementById("invoiceLoading")){
				document.getElementById("invoiceLoading").parentNode.removeChild(document.getElementById("invoiceLoading"));
			}
		},
		clearValidation = function(){
			if(document.querySelector(".input-validation-error")){
				var errors = [].slice.call(document.querySelectorAll(".input-validation-error"));
				errors.forEach(function(el, index, array){
					el.classList.remove("input-validation-error");
					el.parentNode.querySelector(".errorMessage").classList.add("hide");
				});
			}
		},
		getSelectedBillAddrID = function() {
			var addrID = emptyGuid;
			if(document.querySelector(".selectedAddress")){
				addrID = document.querySelector(".selectedAddress").id;
			}
			return addrID;
		},
		getSelectedCCID = function() { // not currently using saved cards here 
			var CCID = emptyGuid;
			var ccChecks = [].slice.call(document.querySelectorAll(".ccCheckbox"));
			ccChecks.forEach(function (el, index, array) {
				if (el.checked) {
					CCID = el.id;
				}
			});		
			return CCID;
		},
		payInvoice = function(){
			showBusy(document.getElementById("btnPayInvoice"));
			var InvoiceID = document.getElementById('txtInvoiceID').value.trim();
			if (isNaN(InvoiceID)) {
				InvoiceID = -1;
			}
			var AmountDue = Math.ceil((document.getElementById('txtAmountDue').value.trim() * 100).toFixed(2));
			window.location.href = window.location.origin + "/payinvoice/" + InvoiceID + "/" + AmountDue;
		},
		showAuthenticationError = function(error){
			hideBusy();
			document.getElementById("btnSubmitPymt").disabled = false;
			var errorPanel =  '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' + 
								'<h3 id="ErrorTitle" class=" validationHeading">Please correct the following errors and resubmit.</h3>' + 
									'<ul><li>There was an error processsing your payment. If you keep getting this error, kindly contact customer support at ' + officePhone + ' for assistance. ' + 
										'We apologize for the inconvenience. Thank you!</li></ul>' +
					 		'</div>';
			document.querySelector('.formHeading').insertAdjacentHTML("afterend", errorPanel);
			document.getElementById("PaymentMethod_CardName").focus();
			window.scrollTo({ top: 0, behavior: "smooth" });
		},
		submitPayment = function(){
			showBusy(document.getElementById('btnSubmitPymt'));
			document.getElementById('btnSubmitPymt').disabled = true;
			var SalesOrderID = document.querySelector('.SalesOrderID').textContent;
			var InvoiceID = document.querySelector('.InvoiceID').textContent;
			var AmountDue = document.querySelector('.AmountDue').textContent.replace('$', '').replace('£','').replace(',', '').replace('/\u00A3/g', '');
			var ccInfo = null;
			var addrInfo = null;
			var addrID = formEvents.GetSelectedBillAddrID();

			if (parseInt(addrID) < 0 || addrID == undefined || addrID == emptyGuid) {
				addrInfo = {
					FirstName: document.getElementById('BillingAddress_FirstName').value, LastName: document.getElementById('BillingAddress_LastName').value,
					AddressLine1: document.getElementById('BillingAddress_AddressLine1').value, AddressLine2: document.getElementById('BillingAddress_AddressLine2').value,
					City: document.getElementById('BillingAddress_City').value, State: document.getElementById('State').value, PostCode: document.getElementById('BillingAddress_PostCode').value
				};
			}
	
			var CCID = formEvents.GetSelectedCCID();
	
			if (parseInt(CCID) < 0 || CCID == undefined || CCID == emptyGuid) {
				ccInfo = {
					CardName: forms.VerifyName(document.getElementById('PaymentMethod_CardName').value), CardNumber: document.getElementById('PaymentMethod_CardNumber').value, 
					CardCCV: document.getElementById('PaymentMethod_CardCCV').value, PaymentTypeID: -1, 
					CardExpirationMonth: document.getElementById('PaymentMethod_CardExpirationMonth').value,
					CardExpirationYear: document.getElementById('PaymentMethod_CardExpirationYear').value, PaymentDescription: ""
					// PaymentTypeID & PaymentDescription determined server side
				};
			}
			
			var data = {
				BillingAddress: addrInfo, 
				InvoiceID: InvoiceID, 
				AmountCharged: AmountDue, 
				PaymentMethod: ccInfo, 
				PaymentCardID: CCID, 
				SalesOrderID: SalesOrderID, 
				BillAddressID: addrID
			};
			
			if (addrInfo != null)
			{
				data.PaymentMethod.Address  = {
					FirstName = addrInfo.FirstName,
					LastName = addrInfo.LastName,
					Address1 = addrInfo.AddressLine1,
					Address2 = addrInfo.AddressLine2,
					City = addrInfo.City,
					State = addrInfo.State,
					ZipCode = addrInfo.PostCode
				};
			}
			else
			{
				data.PaymentMethod.Address = {
					AddressId = addrID
				};
			}
			
			if (authenticationLayer) {
				const email =  document.getElementById('Email').value;
				authentication = authenticationLayer.GetAuthenticationResponse(ccInfo);
				if (authentication.TransactionId == 0) {
					authenticationLayer.Authenticate(data.PaymentMethod, AmountDue, ajaxActions.SendPayment, [data], email);
					return;
				}
			}
			
			ajaxActions.SendPayment(data);
		};
		return{
			ShowBusy: showBusy,
			HideBusy: hideBusy,
			ClearValidation: clearValidation,
			PayInvoice: payInvoice,
			SubmitPayment: submitPayment,
			GetSelectedBillAddrID: getSelectedBillAddrID,
			GetSelectedCCID: getSelectedCCID,
			ShowAuthenticationError: showAuthenticationError
		};
	})(),
	
	ajaxActions = (function(){
		var signIn = async function(){
			// Check if grecaptcha is defined
			// if not, try to fetch the script again 
			if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
			
			// need to show an error if recaptcha script still isn't available
			if(typeof grecaptcha == "undefined"){
				showError();
			}else{
				grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName}).then(function (token) {
					formEvents.ShowBusy(document.getElementById('btnSignIn'));
					document.getElementById('btnSignIn').disabled = true;
					if(document.getElementById("invoiceSignInForm").querySelector("#ErrorBox")){ //remove error panel
						document.getElementById("invoiceSignInForm").querySelector("#ErrorBox").parentNode.removeChild(document.querySelector("#ErrorBox"));
					}
					if(document.getElementById("invoiceSignInForm").querySelector(".loginError")){ //remove error panel
						document.getElementById("invoiceSignInForm").querySelector(".loginError").classList.add("hide");
					}
					var data = { 
						Email: document.getElementById('Email').value, 
						Password: document.getElementById('Password').value,  
						recaptchaActionName: recaptchaActionName, 
						recaptchaToken: token 
					};
					
						        			
					fetch('/invoice/login', { 
						method: 'POST', 
						body: JSON.stringify(data), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch',  "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken}
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						formEvents.HideBusy();
						document.getElementById('btnSignIn').disabled = false;
						if (response.error == "recaptchaNotVerified") {
							document.getElementsByClassName("loginError")[0].classList.remove("hide");
							document.getElementsByClassName("loginError")[0].querySelector("a").href = response.recaptchaVerificationUrl;
							document.getElementsByClassName("loginError")[0].querySelector("a").focus();
						}
						else {
							if (response.success == "true") {
								location.href = "/selectinvoice";
							} else {
								var errorPanel;
								if (response.errorMsg) {
									errorPanel = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' +
													'<h3 id="ErrorTitle" class="validationHeading">' + response.errorMsgHeader + '</h3>' +
														'<ul><li>' + response.errorMsg + '</li></u>' +
												'</div>';
								}else {
									errorPanel = 
										'<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' +
											'<h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit.</h3>' +
												'<ul><li><a href="#Email" tabindex="0" role="link" class="errorItem">Sign in failed. Email or Password is incorrect.</a></li>' + 
													 '<li>If you experience further issues, give us a call at ' + accountingDeptPhone +'</li></ul>' +
										'</div>';
								}
								document.getElementById("invoiceSignInForm").querySelector('.formHeading').insertAdjacentHTML('afterend', errorPanel);
								document.getElementById("Email").classList.add("input-validation-error");
								document.getElementById("Password").classList.add("input-validation-error");
								if (document.getElementById("invoiceSignInForm").querySelector(".ErrorMsgPanel").querySelector("a")) {
									document.getElementById("invoiceSignInForm").querySelector(".ErrorMsgPanel").querySelector("a").focus();
								}
							}
						}
					}).catch(function(error){
						showError();
					});
				});
			}
		},
		
		showError = () => {
			formEvents.HideBusy();
			document.getElementById('btnSignIn').disabled = false;
			var errorPanel =  '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' + 
								'<h3 id="ErrorTitle" class=" validationHeading">Please correct the following errors and resubmit.</h3>' + 
									'<ul><li><a href="#Email" tabindex="0" role="link" class="errorItem">There was an error signing in. Please try again.</a></li>' +
										 '<li>If you experience further issues, give us a call at ' + accountingDeptPhone + '</li></ul>' +
					 		'</div>';
			document.getElementById("invoiceSignInForm").querySelector('.formHeading').insertAdjacentHTML('afterend', errorPanel);
			document.getElementById("Email").classList.add("input-validation-error");
			document.getElementById("Password").classList.add("input-validation-error");
			if (document.getElementById("invoiceSignInForm").querySelector(".ErrorMsgPanel").querySelector("a")) {
				document.getElementById("invoiceSignInForm").querySelector(".ErrorMsgPanel").querySelector("a").focus();
			}
		},
		
		sendPayment = function(theData){

			if(document.getElementById('divSrvErr')){
				document.getElementById('divSrvErr').parentNode.removeChild(document.getElementById('divSrvErr'));
			}
			theData.AuthenticationResponse = { TransactionId: 0 }			
			if (authenticationLayer) {
				theData.AuthenticationResponse = authenticationLayer.GetAuthenticationResponse(theData.PaymentMethod);
			}
			
			fetch('/invoice/authorizepayment', { 
				method: 'POST', 
				body: JSON.stringify(theData), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch',  "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				formEvents.HideBusy();
				document.getElementById("btnSubmitPymt").disabled = false;
				if (!response.includes('ErrorBox')){
					document.querySelector('.DivHelper').innerHTML = response;
				}else { 
					if (authenticationLayer) {
						authenticationLayer.RemoveCard(theData.PaymentMethod);
					}
					document.getElementById("paymentTotalForm").querySelector('.formHeading').insertAdjacentHTML("afterend", response);
					if (document.querySelector('.ErrorMsgPanel')) {
						if (document.getElementById('divSrvErr').querySelector('ul')) {
							document.querySelector('#ErrorMsgBox').insertAdjacentHTML('beforeend', document.getElementById('divSrvErr').querySelector('ul').innerHTML);
						}
					}
					forms.serverValidation(document.getElementById('divSrvErr'));
					document.getElementById('divSrvErr').parentNode.removeChild(document.getElementById('divSrvErr'));
					document.getElementById("PaymentMethod_CardName").focus();
				}
				window.scrollTo({ top: 0, behavior: "smooth" });
			}).catch(function(error){
				formEvents.HideBusy();
				document.getElementById("btnSubmitPymt").disabled = false;
				var errorPanel =  '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' + 
									'<h3 id="ErrorTitle" class=" validationHeading">Please correct the following errors and resubmit.</h3>' + 
										'<ul><li>There was an error processsing your payment. If you keep getting this error, kindly contact customer support at ' + officePhone + ' for assistance. ' + 
											'We apologize for the inconvenience. Thank you!</li></ul>' +
						 		'</div>';
				document.querySelector('.formHeading').insertAdjacentHTML("afterend", errorPanel);
				document.getElementById("PaymentMethod_CardName").focus();
				window.scrollTo({ top: 0, behavior: "smooth" });
			});
		},
		billingAddress = function(el){
			var AddrID = el.id;
			//var data = { AddrID: AddrID };
			if(document.getElementById("paymentTotalForm").querySelector(".ErrorMsgPanel")){ //remove error panel
				document.getElementById("paymentTotalForm").querySelector(".ErrorMsgPanel").parentNode.removeChild(document.querySelector(".ErrorMsgPanel"));
			}
				        			
			fetch('/invoice/getbillingaddress', { 
				method: 'POST', 
				body: JSON.stringify(AddrID), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch',  "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				formEvents.HideBusy();
				document.getElementById('BillingAddressForm').parentNode.removeChild(document.getElementById('BillingAddressForm'));
				var newDiv = document.createElement("div");
				newDiv.innerHTML = response;
				document.querySelector('.billingAddressForm').appendChild(newDiv);
				el.checked = true;
			}).catch(function(error){
				formEvents.HideBusy();
				var errorPanel =  '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' + 
									'<h3 id="ErrorTitle" class=" validationHeading">Please correct the following errors and resubmit.</h3>' + 
										'<ul><li>There was an error retrieving your billing address. If you keep getting this error, kindly contact customer support at ' + officePhone + ' for assistance. ' + 
											'We apologize for the inconvenience. Thank you!</li></ul>' +
						 		'</div>';
				document.querySelector('.formHeading').insertAdjacentHTML("afterend", errorPanel);
				document.getElementById("BillingAddress_FirstName").focus();
				window.scrollTo({ top: 0, behavior: "smooth" });
			});
		};
		return {
			SignIn: signIn,
			SendPayment: sendPayment,
			BillingAddress: billingAddress
		};
	})();
	
/*	otherEvents = function(){
		// this portion is disabled in the HTML for now - please test if enabled
		var ccChecks = [].slice.call(document.querySelectorAll(".ccCheckbox"));
		ccChecks.forEach(function(el, index, array){
			var uncheckAll = function(){
				el.checked = false;
			};
			el.addEventListener('change', function () {
				el.checked = true;
				document.querySelector('.pnlPayment').parentNode.removeChild(document.querySelector('.pnlPayment'));
				var textInputs = [].slice.call(document.getElementById('PaymentForm').querySelectorAll('input[type=text]'));
				var selects = [].slice.call(document.getElementById('PaymentForm').querySelectorAll('select'));
				if (el.checked) {
					//disables cc input form
					selects.forEach(function(el, index, array){
						el.disabled = true;
					});
					textInputs.forEach(function(el, index, array){
						el.disabled = true;
					});
				} else {
					//enables cc input form
					selects.forEach(function(el, index, array){
						el.disabled = false;
					});
					textInputs.forEach(function(el, index, array){
						el.disabled = false;
					});
				}
				selects.forEach(function(el, index, array){
					el.style.backgroundColor = "#fff";
				});
				textInputs.forEach(function(el, index, array){
					el.style.backgroundColor = "#fff";
				});
			});
		});	
	}, */
	
	return{
		Init: init
	};
};

(function(){
	var invoicePage = new invoice4i();
	invoicePage.Init();
})()